var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"kontainer"},[_c('div',[_vm._v("Art:")]),_vm._l((_vm.auswahlListen.art),function(item,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(item.text)+" ")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }